import { ApolloProvider } from '@apollo/client';
import { ChakraProvider } from '@chakra-ui/react';
import React from 'react';
import cms from './apis/cms';
import { AuthProvider } from './hooks/useAuth';
import { MenuLocationsProvider } from './hooks/useMenuItemsLocation';
import Routes from './Routes';
import light from './styles/themes/light';

const App: React.FC = () => {
  return (
    <ApolloProvider client={cms.graphql}>
      <AuthProvider>
        <MenuLocationsProvider>
          <ChakraProvider theme={light}>
            <Routes />
          </ChakraProvider>
        </MenuLocationsProvider>
      </AuthProvider>
    </ApolloProvider>
  );
};

export default App;
